import React from 'react';
import { Typography } from '@mui/material';
import VariableTextField from '../../VariableTextField';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { TextHeadingCore } from '../../../../flow-core/components/TextHeadingCore';

export const TextHeadingComponent = new FlowComponent({
  ...TextHeadingCore,
  renderPreview(properties) {
    return (
      // Match WhatsApp's TextHeading: ~24px bold, not MUI h4 (34px) which rendered far larger than
      // the real flow and wrapped onto two lines.
      <Typography
        component="h1"
        gutterBottom
        sx={{ fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.3 }}
      >
        {properties.text || 'Heading Text'}
      </Typography>
    );
  },
  renderPropertyEditor(properties, onChange, context) {
    return (
      <VariableTextField
        fullWidth
        label="Text"
        value={properties.text || ''}
        onChange={(e) => onChange('text', e.target.value)}
        required
        inputProps={{ maxLength: 80 }}
        helperText={`${(properties.text || '').length}/80 characters, use {x} to insert field references`}
        size="small"
        screens={context?.screens}
        currentScreenId={context?.currentScreenId}
      />
    );
  },
});
